import React, {useEffect, useState} from 'react';
import {useAuth} from "../../../context/authContext";
import {Alert} from "react-bootstrap";
import {closeReleaseNoteMessage, showNewReleaseBanner} from '../../../actions/broadcastMessengerActions';
import {AppPropertiesUtil} from "../../../utils/localStorageUtil";

const BroadcastNewReleaseNoteMessage = () => {
    const auth = useAuth();
    const token = auth.getAuthToken();
    const [hidden, setHidden] = useState(true);
    const releaseNotesPdf = "/documentation/Release_Notes.pdf";

    useEffect(() => {
        (async () => {
            const response = await showNewReleaseBanner(token);
            if (response) {
                setHidden(false);
            }
        })();
    }, [token]);

    const hideMessage = async () => {
        if (auth.isAuthenticated()) {
            await closeReleaseNoteMessage(token);
            setHidden(true);
        } else {
            setHidden(true);
        }
    }

    return (
        <>
            {!hidden ? (
                <Alert variant="success" className="position-absolute top-0 start-50 translate-middle-x zindex-1040 rounded-0">
                    <div className="d-flex justify-content-between">
                        <span className="me-4">CareEmpower Release {AppPropertiesUtil.get('ce.release.version')} is live! Click <a href={releaseNotesPdf} onClick={hideMessage} target="blank">here</a> to learn about the newest features and updates.</span>
                        <span><i onClick={hideMessage} className="fa fa-times fa-lg cursor-p"></i></span>
                    </div>
                </Alert>
            ) : null}
        </>
    );
}
export default BroadcastNewReleaseNoteMessage;